// Capacitor 네이티브 다운로드 플러그인 로더. 웹/데스크톱에서는 null 을 반환해
// 호출부(downloadStore)가 웹 fetch 경로로 폴백하게 한다. Haptics.ts 와 같은 규약:
// @withtask/capacitor-native-download 를 정적 import 하지 않고(웹 번들 오염 방지)
// isCapacitorNative() 로 게이트한 뒤에만 동적 import 한다 — apps/ui dist 에는 bare
// import 로만 남고(vite external) apps/app 이 vendor-capacitor 청크로 분리한다.

import { isCapacitorNative } from "shared/features/platform";

export type NativeDownloadModule = typeof import("@withtask/capacitor-native-download");

/** 네이티브면 플러그인 모듈, 아니면 null. */
export async function loadNativeDownload(): Promise<NativeDownloadModule | null> {
  if (!isCapacitorNative()) return null;
  return import("@withtask/capacitor-native-download");
}
